//export const API_BASE_URL = 'http://35.232.239.99/api/v1';
export const API_BASE_URL = 'https://api.inovafrancesinha.pt/api/v1';